__turbopack_context__.v({
  "dark": "social-links-module-scss-module__kPjica__dark",
  "light": "social-links-module-scss-module__kPjica__light",
  "link": "social-links-module-scss-module__kPjica__link",
  "social-media": "social-links-module-scss-module__kPjica__social-media",
});
